import React from 'react';
import { Grid } from '@mui/material';
import { SummaryRow } from './summary-row/SummaryRow';
import { observer } from 'mobx-react';
import { useLocalStore } from '../local-store-provider/LocalStoreProvider.utils';
import { RevenueCalculatorStore } from '../revenue-calculator/RevenueCalculator.store';
import { COLORS_GREEN } from '../../App.constants';

export const Summary: React.FC = observer(() => {
  const localStore = useLocalStore<RevenueCalculatorStore>();

  return (
    <Grid
      alignSelf={'center'}
      bgcolor={COLORS_GREEN}
      paddingX={2}
      paddingY={1}
      marginBottom={4}
      marginTop={1}
      width={'100%'}
    >
      <SummaryRow
        text={'Revenue Potential in your Business Today'}
        value={localStore.currentRevenuePotential}
      />

      <SummaryRow
        text={'Current Annual Revenue'}
        value={localStore.startingAnnualRevenue}
        borderBottom={'1px solid #DFDFDF'}
        paddingBottom={1}
      />
      <SummaryRow
        text={'Un-captured Annual Revenue'}
        value={localStore.unCapturedRevenue}
        fontSize={'1.5rem'}
      />
    </Grid>
  );
});

Summary.displayName = 'Summary';
